module.exports = __webpack_public_path__ + "static/media/arrow-up-blue.850d8960.svg";